import React from 'react';
import styles from './TableSelector.module.scss';

function TableWithoutHeader(props) {
    const { attributes, children } = props;

    return (
        <table className={styles.TableWithoutHeaders}>
            <tbody {...attributes}>{children}</tbody>
        </table>
    );
}

export default TableWithoutHeader;
